import { useRefreshBookingData } from "PFApp/booking/hooks/use_refresh_booking_data";
import { useBookingsOverviewContext } from "PFApp/booking/parts/overview/context/bookings_overview_context";
import { useSyncRows } from "PFApp/booking/parts/overview/use_sync_rows";
import { useBookingModuleContext } from "PFApp/booking/parts/providers/booking_module_context_provider";
import { useGrowl } from "PFApp/use_growl";
import { useErrorsGrowl } from "PFCore/hooks/use_errors_growl";
import { SplitBookingResponse } from "PFCore/services/split_booking";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";

import { useBookingBarContext } from "../../booking_bar_provider";

interface UseSuccessErrorHandlersReturn {
  onSuccess: (data: SplitBookingResponse) => void;
  onError: (response: any) => void;
}

export const useSuccessErrorHandlers = (): UseSuccessErrorHandlersReturn => {
  const { setSplitMode } = useBookingsOverviewContext();
  const { booking } = useBookingBarContext();
  const { t } = useTranslation("bookingModule");
  const growl = useGrowl();
  const growlErrors = useErrorsGrowl();
  const syncRows = useSyncRows();
  const refreshBookingData = useRefreshBookingData();
  const { setHeaderDisabled } = useBookingModuleContext();

  const exitSplitMode = () => {
    setSplitMode(false);
    setHeaderDisabled(false);
  };

  const onSuccess = useCallback(
    ({ existingBooking }: SplitBookingResponse) => {
      if (!booking) {
        return;
      }
      const { activity, profile_id: profileId } = booking;
      const { id: activityId, parent_activity: parentActivity } = activity || {};
      const { id: parentActivityId } = parentActivity || {};
      refreshBookingData({
        bookingIds: [existingBooking.id],
        activityId,
        profileId,
        refreshProfile: booking.booking_template_id != null // eslint-disable-line eqeqeq
      });
      syncRows({ activityId, profileId, parentActivityIds: [parentActivityId] });
      exitSplitMode();
      growl({ message: t("splitMode.success") });
    },
    [booking, syncRows]
  );

  const onError = useCallback(({ response }) => {
    growlErrors(response);
  }, []);

  return { onSuccess, onError };
};
